import { render, staticRenderFns } from "./VersionUpdateToast.vue?vue&type=template&id=5d2d2c6c&scoped=true&"
import script from "./VersionUpdateToast.vue?vue&type=script&lang=js&"
export * from "./VersionUpdateToast.vue?vue&type=script&lang=js&"
import style0 from "./VersionUpdateToast.vue?vue&type=style&index=0&id=5d2d2c6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2d2c6c",
  null
  
)

export default component.exports